import apiCore from '../../utils/api-core';


export function getUserNotifications(query) {
    let path = '/api/v1/notifications';
    if (query) {
        path = `${path}?${query}`;
    }

    return apiCore.get(path);
}

export function readNotifications(data) {
    return apiCore.put('/api/v1/notifications/is-read', data);
}

export function readContactNotifications(contactId){
    return apiCore.put(`/api/v1/notifications/contact/is-read/${contactId}`)
}
